import { useQuery } from "@tanstack/react-query"
import { conversationsResponsesQuery } from "../lib/conversationsResponsesQuery"

export function useConversationsResponsesQuery(
  ...args: Parameters<typeof conversationsResponsesQuery>
) {
  return useQuery(conversationsResponsesQuery(...args))
}
